import React, { useEffect, useState } from 'react';
import Header from 'pages/Header/HeaderNavegacion';
import BarraCP from 'components/BarCP/BarHeaderCP';
import { decodeStorage } from 'functions/storageBase64';
import Footer from 'pages/Footer/FooterDesktop';
import { MenuPoliticas } from 'components/MenuAutocenter/menuAutocenter';
import "./style.sass";
import { useHistory } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile';

const title = "Aviso de Privacidad Tarjeta Mágica SEARS";

const TextDataPrivacidad = () => {

    return (
        <div className="contentTextData">
            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Quién dará tratamiento a sus datos personales?</h2>
                    <p>GS Tiendas Departamentales, S. A. de C. V., (en adelante Sears) con domicilio en Lago Zúrich No. 245, Edificio Presa Falcón piso 7, colonia Ampliación Granada, alcaldía Miguel Hidalgo, C.P. 11529, Ciudad de México, será el responsable del tratamiento de sus datos personales.</p>
                    <p>Para cualquier duda relacionada con la protección de sus datos personales podrá contactar a nuestro Departamento de Protección de Datos de Sears a la dirección electrónica <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué información vamos a recabar?</h2>
                    <p>Sears para cumplir con las finalidades señaladas en el presente Aviso de Privacidad tratará las siguientes categorías de datos personales: (i) datos personales de identificación; (ii) datos personales de contacto, y (iii) datos personales patrimoniales y/o financieros de menores de edad respecto de los cuales usted sea padre y/o tutor. Al proporcionar dichos datos usted reconoce que ha leído este Aviso de Privacidad y otorga su consentimiento para que Sears realice el tratamiento de conformidad con lo dispuesto en el presente documento.</p>
                    <p>Sears no recabará ni tratará datos personales sensibles. En caso de que usted nos contacte por redes sociales, podremos recabar los datos de su perfil público de redes sociales para darle atención a sus peticiones y/o solicitudes de información en relación con los productos que ofrecemos.</p>
                    <p>Le informamos que para efectos de lo señalado en el presente Aviso de Privacidad Sears podrá dar tratamiento a datos personales de terceros, por lo que al proporcionar los datos personales de dichos terceros para que Sears les contacte por medios físicos y/o electrónicos usted reconoce haber recabado el consentimiento requerido en términos de la normatividad aplicable.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Tratamiento automatizado de datos sin decisión humana valorativa y actividades de perfilamiento</h2>
                    <p>Le informamos que para dar cumplimiento a las finalidades previstas en este Aviso de Privacidad Sears realizará tratamientos automatizado de datos personales como parte de un proceso de toma de decisiones sin intervención humana valorativa y técnicas de análisis masivo de datos para realizar actividades de perfilamiento a partir de sus hábitos de consumo, gustos e intereses, monitorear su comportamiento y ofrecerle una experiencia personalizada en relación con el uso de los servicios, así como para dar cumplimiento a algunas(s) de las finalidades(es) informadas en el presente Aviso de Privacidad.</p>
                    <p>Si usted no desea que sus datos personales sean utilizados mediante mecanismos o tecnologías automatizadas, puede oponerse a ese tratamiento en cualquier momento siguiendo el procedimiento para el ejercicio de sus derechos ARCO.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Para qué fines usamos su información?</h2>
                    <p>Sears tratará sus datos personales para las siguientes finalidades primarias y necesarias:</p>
                    <ul className="ulQuestionDisc">
                        <li>Gestionar la solicitud de la Tarjeta Mágica;</li>
                        <li>Verificar la identidad del padre o tutor y la relación con el menor;</li>
                        <li>Registrar y administrar el uso de la Tarjeta Mágica;</li>
                        <li>Procesar los depósitos y transacciones realizadas con la tarjeta;</li>
                        <li>Identificarle y contactarlo para dar seguimiento a la entrega de los productos adquiridos;</li>
                        <li>Atender y resolver sus dudas relacionadas con el uso de la tarjeta y la adquisición de productos;</li>
                        <li>Acreditar, validar y verificar su identidad;</li>
                        <li>Para dar cumplimiento a lo dispuesto por la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita;</li>
                        <li>Realizar consultas, investigaciones y revisiones en relación a quejas o reclamaciones;</li>
                        <li>Para las gestiones de facturación relacionadas con las transacciones realizadas;</li>
                        <li>Llevar un histórico de compras y uso de la tarjeta;</li>
                        <li>Para contactar a través de llamadas telefónicas, envío de comunicaciones a través de correos electrónicos, mensajes cortos y demás medios de comunicación físicos y/o electrónicos;</li>
                        <li>Identificarlo como visitante en nuestras sucursales y/o como participante en dinámicas y promociones;</li>
                        <li>Dar atención a sus solicitudes de información, quejas o reclamaciones;</li>
                        <li>Dar cumplimiento a las obligaciones derivadas de la relación jurídica con usted;</li>
                        <li>Dar cumplimiento a obligaciones previstas en la normatividad aplicable.</li>
                    </ul>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Qué otros usos podemos darle a su información?</h2>
                    <p>De manera adicional, si usted no se opone, Sears podrá tratar su información personal para las siguientes finalidades secundarias:</p>
                    <ul className="ulQuestionDisc">
                        <li>Informarle sobre promociones, ofertas y nuevos beneficios asociados a la Tarjeta Mágica y otros servicios de Sears y Empresas del Grupo;</li>
                        <li>Compartir perfiles y hábitos de consumo con socios comerciales para enviarle publicidad que consideremos de su interés;</li>
                        <li>Para enviarle comunicaciones con fines de mercadotecnia, tele-marketing y publicidad personalizada.</li>
                    </ul>
                    <p>En caso de que no desee que sus datos sean tratados para estas finalidades, puede comunicarlo al correo <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿A qué terceros podemos transferir su información?</h2>
                    <p>Sears podrá transferir sin requerir de su consentimiento los datos necesarios a autoridades competentes, así como a empresas Subsidiarias, afiliadas o bajo control Común para dar cumplimiento a las finalidades señaladas.</p>
                    <p>Podrá entregar información a autoridades fiscales en cumplimiento con la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita.</p>
                    <p>Transferirá datos a socios comerciales y terceros prestadores de servicios relacionados con la administración de la tarjeta y programas de lealtad.</p>
                    <p>Si usted no se opone, Sears podrá transferir datos a socios comerciales para que le ofrezcan bienes y servicios. Puede oponerse enviando un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a></p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede ejercer sus derechos ARCO y/o revocar su consentimiento?</h2>
                    <p>Usted o su representante legal podrá ejercer los derechos de acceso, rectificación, cancelación u oposición enviando un correo a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a>.</p>
                    <p>Debe solicitar el Formato de Solicitud de Derechos ARCO a dicha dirección y acompañarlo con copia de una identificación oficial vigente y los documentos que acrediten la representación del menor.</p>
                    <p>El plazo de respuesta es de veinte (20) días hábiles, haciéndose efectiva en los quince (15) días siguientes si resulta procedente.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo puede limitar el uso y/o divulgación de sus datos?</h2>
                    <p>Podrá limitar el uso o divulgación enviando su solicitud a <a href="mailto:arco@sears.com.mx">arco@sears.com.mx</a> para ser registrado en el listado de exclusión propio de Sears.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>¿Cómo le notificaremos de los cambios que efectuemos al presente Aviso de Privacidad?</h2>
                    <p>Sears le notificará de cualquier cambio a través de su página de internet <a href="http://www.sears.com.mx" target="_blank" rel="noopener noreferrer">http://www.sears.com.mx</a>.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Autoridad de Protección de Datos Personales (UPDP-SABG)</h2>
                    <p>Tiene el derecho de acudir ante la Unidad de Protección de Datos Personales de la Secretaría Anticorrupción y Buen Gobierno (SABG) para hacer efectivos sus derechos.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <h2>Aceptación de Aviso de Privacidad</h2>
                    <p>Al hacer uso de nuestros servicios y proporcionar sus datos, significa que usted ha leído, entendido, y acordado los términos expuestos en el presente Aviso de Privacidad.</p>
                </div>
            </div>

            <div className="contentPreguntasInt">
                <div className="question1">
                    <p><span className='bold'>Fecha de última actualización:</span> enero 2026</p>
                </div>
            </div>
        </div>
    )
}

export function TarjetaMagicaDesktop() {
    const codigoP = decodeStorage('codigoPostal');
    const [codigoPostal, setCodigoPsotal] = useState(codigoP);

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Programa Infantil - Tarjeta Magica Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        //setLoading(false)
    }, [codigoPostal])

    //recibe la direccion del CP
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
            //console.log('')
        }
    }, [upCP, updateCPBar])

    return (
        <>
            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
            <section className="barCpResponsive">
                <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
            </section>

            <main>
                <section className="sectionAuto">
                    <div className="sectionMenu">
                        <MenuPoliticas />
                    </div>

                    <div className="sectionContent">
                        <section className="sectionTitleAuto">
                            <div className="divTitle">
                                <p>{title}</p>
                            </div>
                        </section>
                        <TextDataPrivacidad />
                    </div>
                </section>
            </main>

            <Footer />

        </>
    )
}

export function TarjetaMagicaMobile() {

    const history = useHistory();
    const isNativeApp = window.location.search.indexOf('isNativeApp=true')
    // cerrar modal
    const onClose = () => {
        // history.goBack(-1);
        window.location.href = "/acerca-sears"
    }

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Programa Infantil - Tarjeta Magica Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <div className="modalDetallePedido full">
                <div className="contentModal">
                    {isNativeApp < 0
                        ?
                            
                            <div className="contentCloseAN">
                                <div className="btn closeBack" onClick={onClose} ></div>
                                <p className="title">{title}</p>
                            </div>
                        : null 
                    }
                    <TextDataPrivacidad />
                </div>
            </div>
        </>
    )
}

export function TarjetaMagica() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Programa Infantil - Tarjeta Magica Page');
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            {isMobile &&
                isMobile === 'desktop'
                ? <TarjetaMagicaDesktop />

                : isMobile === 'movile'
                    ? null
                    : <TarjetaMagicaMobile />
            }
        </>
    )
}

